<template>
  <router-view />
  <CustomerService v-if="$route.name !== 'Splash' && !$route.path.startsWith('/admin')" />
</template>

<script>
import CustomerService from '@/components/CustomerService.vue';

export default {
  name: 'App',
  components: { CustomerService }
};
</script>

<style>
body {
  background: var(--color-body-bg);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
  margin: 0;
  min-height: 100vh;
  color: #333;
}
</style>
